import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  input: {
    '&  ::placeholder': {
      opacity: 0.6,
    },
  },
}))

export default useStyles
